import React, { useState } from "react";
import { Toggle, Author } from "./ui";
import { FF, T } from "../lib/constants";
import { noteDate } from "../lib/notes";

// Notities bij één les (build 2.5): je eigen notitie (privé of gedeeld met de club) en
// daaronder de gedeelde notities van collega's bij dezelfde les.
// `compact`: notities van collega's ingeklapt achter één knop (telefoon/weekoverzicht).
export default function NotesPanel({ mine, others, onText, onShare, solo, status, compact, label }) {
  var [open, setOpen] = useState(false);
  var [id] = useState(function () { return "nt" + Math.random().toString(36).slice(2, 8); });
  var text = mine ? mine.text || "" : "";
  var list = others || [];
  var showOthers = !compact || open;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10, fontFamily: FF }}>
      <section style={{ background: T.card, border: "1px solid " + T.line2, borderRadius: 16, padding: "12px 14px", display: "flex", flexDirection: "column", gap: 8 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", gap: 8 }}>
          <label htmlFor={id} style={{ margin: 0, fontSize: 16, fontWeight: 800, color: T.ink, display: "flex", alignItems: "center", gap: 6 }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 3h10l4 4v14H5z" /><path d="M9 11h6M9 15h6" /></svg>
            Mijn notities
          </label>
          <span role="status" style={{ fontSize: 12, fontWeight: 700, color: status === "error" ? "#B83232" : status === "saving" ? T.muted : "#2F7D47", minHeight: 16 }}>
            {status === "saving" ? "Opslaan…" : status === "saved" ? "Opgeslagen" : status === "error" ? "Niet opgeslagen" : ""}
          </span>
        </div>
        {label && <p style={{ margin: 0, fontSize: 12, color: T.muted }}>{"Bij deze les: " + label}</p>}
        <textarea id={id} value={text} rows={compact ? 3 : 6} onChange={function (e) { onText(e.target.value); }}
          placeholder="Wat ging goed, wat pas je volgende keer aan?"
          style={{ width: "100%", boxSizing: "border-box", border: "1px solid " + T.line, borderRadius: 10, padding: 10, fontSize: 15, lineHeight: 1.55, color: T.ink, resize: "vertical", background: "#FFFDF6", fontFamily: FF, outline: "none" }} />
        {!solo && (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10, paddingTop: 4, borderTop: "1px solid " + T.line }}>
            <span style={{ fontSize: 13, color: "#4A4740", lineHeight: 1.35 }}>
              <strong style={{ display: "block", fontSize: 14, color: T.ink }}>Delen met club</strong>
              {mine && mine.shared ? "Collega's zien je notitie bij deze les" : "Alleen jij ziet deze notitie"}
            </span>
            <Toggle on={!!(mine && mine.shared)} label="Delen met club" onClick={function () { onShare(!(mine && mine.shared)); }} />
          </div>
        )}
      </section>

      {!solo && list.length > 0 && compact && (
        <button type="button" aria-expanded={open} onClick={function () { setOpen(!open); }}
          style={{ minHeight: 46, borderRadius: 12, border: "1px solid " + T.line2, background: T.soft, display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0 14px", fontSize: 14, fontWeight: 700, color: T.primary, cursor: "pointer", fontFamily: FF }}>
          <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ background: T.primary, color: "#fff", borderRadius: 999, fontSize: 12, padding: "1px 8px" }}>{list.length}</span>
            {list.length === 1 ? "Notitie van een collega" : "Notities van collega's"}
          </span>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" aria-hidden="true" style={{ transform: open ? "rotate(180deg)" : "none" }}><path d="M6 9l6 6 6-6" /></svg>
        </button>
      )}
      {!solo && list.length > 0 && showOthers && (
        <section style={{ background: T.soft, border: "1px solid " + T.line2, borderRadius: 16, padding: "12px 14px", display: "flex", flexDirection: "column", gap: 8 }}>
          {!compact && <h2 style={{ margin: 0, fontSize: 14, fontWeight: 800, color: T.ink }}>Van collega's bij deze les</h2>}
          {list.map(function (n) {
            return (
              <div key={n.id} style={{ background: T.card, border: "1px solid " + T.line2, borderRadius: 12, padding: "10px 12px" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 4, flexWrap: "wrap" }}>
                  <Author name={n.ownerName} />
                  <span style={{ fontSize: 12, color: T.muted }}>{noteDate(n) ? "· " + noteDate(n) : ""}</span>
                </div>
                <p style={{ margin: 0, fontSize: 13, lineHeight: 1.5, color: "#4A4740", whiteSpace: "pre-wrap" }}>{n.text}</p>
              </div>
            );
          })}
        </section>
      )}
    </div>
  );
}
